import React, { useState } from 'react';
import PropTypes from 'prop-types';

const RadioGroup = ({ field, form: { touched, errors }, ...props }) => {
  const { label, options, change, required } = props;
  const [checked, setChecked] = useState(field.value);

  function setVal(val) {
    setChecked(val);
    change(val);
  }

  return (
    <div>
      <label className='block uppercase tracking-wide text-gray-700 text-sm font-semibold mb-2'>
        {label}
        {required && <span className='text-red-500 ml-1'>*</span>}
      </label>
      <div className='flex flex-col md:flex-row'>
        {options.map((option, index) => (
          <label key={index} className='flex items-center mr-6'>
            <input
              {...field}
              type='radio'
              checked={checked === option.value ? true : false}
              onChange={() => setVal(option.value)}
            />
            <div className='ml-2'>{option.label}</div>
          </label>
        ))}
      </div>
      {touched[field.name] && errors[field.name] && (
        <div className='text-xs text-red-500'>{errors[field.name]}</div>
      )}
    </div>
  );
};

RadioGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  required: PropTypes.bool,
  options: PropTypes.array,
  field: PropTypes.object,
  form: PropTypes.object,
  change: PropTypes.func,
};

export default RadioGroup;
